import { PARTNER_ID } from 'common/constants';
import { getCookie } from 'helpers/saveToCookies';
import { getDecryptJwtToken } from './getQueryStringUrl';

const getCookieOrUrlPartnerId = () => {
  if (getDecryptJwtToken()?.partnerId) {
    return getDecryptJwtToken().partnerId;
  }
  if (getCookie(PARTNER_ID).length > 2) {
    return getCookie(PARTNER_ID);
  }
};

export const getPartnerId = getCookieOrUrlPartnerId();
